"use client";
import { useEffect, useState } from "react";
import { set } from "react-hook-form";

export function PasswordPrompt() {
  const [password, setPassword] = useState("");
  const [auth, setAuth] = useState(false);
  async function handleSubmit(event) {
    event.preventDefault();
    // Set is authenticated cookie to true if password is correct
    const res = await fetch("/api/auth", {
      method: "POST",
      body: JSON.stringify({ password }),
    });
    // Reload the page
    if (res.ok) {
      setAuth({
        status: "authenticated",
        message: "Correct password, Redirecting...",
      });
      window.location.reload();
    } else {
      setAuth({
        status: "error",
        message: "Incorrect password, please try again.",
      });
    }
  }

  useEffect(() => {
    setAuth(false);
  }, [password]);

  return (
    <div className="flex flex-col items-center justify-center w-screen h-full">
      <h1 className="text-2xl font-bold">Password Protected</h1>
      <form onSubmit={handleSubmit} className="flex justify-center w-full">
        <label htmlFor="password" className="sr-only">
          Password
        </label>
        <input
          className="w-auto pl-3 pr-6 border rounded-l-button-radius h-11 para focus:outline-none"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          id="password"
        />
        <button
          className="px-4 -ml-4 text-base font-button font-semibold rounded-r-button-radius bg-button text-button-foreground"
          type="submit"
        >
          Submit
        </button>
      </form>
      <div className="flex items-center justify-center h-12">
        {auth && (
          <p
            className={
              auth?.status == "error" ? "text-red-600" : "text-green-600"
            }
          >
            {auth.message}
          </p>
        )}
      </div>
    </div>
  );
}
